export const isFlexibleReportsM2P1Enabled = () => {
  return window.AppContext?.isFlexibleReportsM2P1Enabled === 'true';
};

export const isCaracalOnlineExperienceEnabled = () => {
  return window.AppContext?.isCaracalUnboxedP0Enabled === 'true';
};

export const isFlexibleReportsCampaignFilterEnabled = () => {
  return window.AppContext?.isFlexibleReportsM2CampaignsFilterEnabled === 'true';
};

export const isFlexibleReportsFeedbackSystemEnabled = () => {
  return window.AppContext?.isFlexibleReportsFeedbackSystemEnabled === 'true';
};

export const isCostEstimationLaunchEnabled = () => {
  return window.AppContext?.isCostEstimationLaunchEnabled === 'true';
};

export const isUnifiedReportingEnabled = () => {
  return window.AppContext?.isUnifiedReportingEnabled === 'true';
};

export const isExtendedHistoricalDataEnabled = () => {
  return window.AppContext?.isDatePresetEnabled === 'true';
};

export const isTimeZoneEnabled = () => {
  return window.AppContext?.isTimeZoneEnabled === 'true';
};

export const isCaracalCovEnabled = () => {
  return window.AppContext?.isCaracalCovEnabled === 'true';
};

export const defaultCovFromAppContext = () => {
  return (window.AppContext?.currencyOfVisualization as string) || 'USD';
};

export const isManagerAccountReportingEnabled = () => {
  return window.AppContext?.isCaracalManagerAccountsEnabled === 'true';
};

export const shouldExcludeManagerAccounts = (): boolean => {
  return isUnifiedReportingEnabled() && !isManagerAccountReportingEnabled();
};

export const isCaracalSpProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalSpProductTypeOptionEnabled === 'true';
};

export const isCaracalSbProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalSbProductTypeOptionEnabled === 'true';
};

export const isCaracalSdProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalSdProductTypeOptionEnabled === 'true';
};

export const isCaracalStvProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalStvProductTypeOptionEnabled === 'true';
};

export const isCaracalOtherProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalOtherProductTypeOptionEnabled === 'true';
};

export const isBonoboFullFunnelAnalysisEnabled = () => {
  return window.AppContext?.isBonoboFullFunnelAnalysisEnabled === 'true';
};

export const isCaracalMetadataDefaultLocaleEnabled = () => {
  return window.AppContext?.isCaracalMetadataDefaultLocaleEnabled === 'true';
};

export const isCaracalOutageBannerEnabled = () => {
  return window.AppContext?.isCaracalOutageBannerEnabled === 'true';
};

export const isCaracalReportHmhEnabled = () => {
  return window.AppContext?.isCaracalReportHmhEnabled === 'true';
};

export const isCaracalSaveAndRunFeatureEnabled = () => {
  return window.AppContext?.isCaracalSaveAndRunFeatureEnabled === 'true';
};

export const isCaracalLTABannerEnabled = () => {
  return window.AppContext?.isCaracalLTABannerEnabled === 'true';
};

export const isBonoboAnalysisReportSourceColumnsEnabled = () => {
  return window.AppContext?.isBonoboAnalysisReportSourceColumnsEnabled === 'true';
};

export const isMTAMetricsEnabled = () => {
  return window.AppContext?.isCaracalMTAEnabled === 'true';
};

export const isAMCTemplateAnalysisEnabled = () => {
  return window.AppContext?.isCaracalAmcIntegrationEnabled === 'true';
};

export const isCaracalLargeAccountsBannerEnabled = () => {
  return window.AppContext?.isCaracalLargeAccountsBannerEnabled === 'true';
};

export const isCaracalInternalUser = () => {
  return window.AppContext?.isInternalUser === 'true';
};

export const isCaracalA3CIntegrationEnabled = () => {
  return window.AppContext?.isBonoboExperienceEnabled === 'true';
};

export const isBonoboAnalysisRfTemplateEnabled = () => {
  return window.AppContext?.isBonoboAnalysisRfTemplateEnabled === 'true';
};

export const isBonoboAnalysisEnabled = () => {
  return window.AppContext?.isBonoboAnalysisEnabled === 'true';
};

export const isCaracalAccountPickerPaginationEnabled = () => {
  return window.AppContext?.isCaracalAccountPickerPaginationEnabled === 'true';
};

export const isMdsDynamicRulesEnabled = () => {
  return window.AppContext?.isMdsDynamicRulesEnabled === 'true';
};

export const isCaracalSingleAccountAutoSelectEnabled = () => {
  return window.AppContext?.isCaracalSingleAccountAutoSelectEnabled === 'true';
};

export const isRoutingToAAO = () => {
  return window.AppContext?.isRoutingToAAO === 'true';
};

export const isCaracalFieldDescriptionTooltipsEnabled = () => {
  return window.AppContext?.isCaracalFieldDescriptionTooltipsEnabled === 'true';
};

export const isCaracalHMHColumnPickerEnabled = () => {
  return window.AppContext?.isCaracalHMHColumnPickerEnabled === 'true';
};

export const isAnalysisWorkspaceEnabled = () => {
  return window.AppContext?.isAnalysisWorkspaceEnabled === 'true';
};
